<template>
  <v-footer id="dashboard-core-footer" padless class="footer"> 
    <v-row align="center" justify="center">
      <v-col cols="12" md="auto" class="pa-0">
        <div class="caption pt-0 pt-md-0 text-center">
          Copyright 2025 &copy; Innotech Laboratory Service Co., Ltd.
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      data1: '',
      /* links: [
        {
          href: '#',
          text: 'Creative Tim',
        },
        {
          href: '#',
          text: 'About Us',
        },
        {
          href: '#',
          text: 'Blog',
        },
        {
          href: '#',
          text: 'Licenses',
        },
      ], */
    }),
  }
</script>

<style scoped>
.footer {
  background: #003057;
}
.footer .caption {
  color: #fff;
}
</style>
